// src/components/AboutSection.jsx
import React from "react";
import AboutTestimonialSection from "./Abouttestomonials";
import VisionMission from "./Visionn";

export default function AboutSection() {


  return (
<>



  <section className="inner-banner-wrap">
      <div
        className="inner-baner-container"
        style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
      >
        <div className="container">
          <div className="inner-banner-content">
            <h1 className="inner-title">About us</h1>
          </div>
        </div>
      </div>
      <div className="inner-shape"></div>
    </section>

    <section className="about-section about-page-section">
      <div className="about-service-wrap">
        <div className="container">
          <div className="section-heading">
            <div className="row align-items-end">
              <div className="col-lg-6 pb-5">
                <img src="images/crysta.jpg"/>
              </div>
              <div className="col-lg-6">
                     <h5 className="dash-style">About Us</h5>
                <div className="section-disc">
                  <p>
                 At Prince Cabs, we are committed to creating personalized travel experiences that connect you to your destination with comfort, reliability, and ease. We believe that every journey should be seamless, safe, and truly memorable.

Prince Cabs specializes in delivering high-quality transportation solutions tailored to the unique needs of our customers. Whether you're traveling for business or leisure, we offer punctual, secure, and comfortable rides with a fleet of well-maintained vehicles operated by professional and courteous drivers.

From airport transfers and local sightseeing to corporate commutes and point-to-point travel, Prince Cabs provides dependable service backed by transparency and affordability. Our user-friendly booking platform and 24/7 customer support ensure a smooth and stress-free experience — every time.

                  </p>
                  <p>
                    
At Prince Cabs, your safety, convenience, and satisfaction are at the heart of everything we do — making us the trusted choice for worry-free travel.
                  </p>
                </div>
              </div>
            </div>
          </div>

        <div className="about-service-container">
  <div className="row">
    <div className="col-lg-4">
      <div className="about-service">
        <div className="about-service-icon">
          <img src="/images/icon15.png" alt="Affordable price" />
        </div>
        <div className="about-service-content">
          <h4>AFFORDABLE PRICE</h4>
          <p>Enjoy premium cab services at competitive rates. Prince Cabs ensures you get value without compromising on comfort or safety.</p>
        </div>
      </div>
    </div>

    <div className="col-lg-4">
      <div className="about-service">
        <div className="about-service-icon">
          <img src="/images/icon16.png" alt="Wide Coverage" />
        </div>
        <div className="about-service-content">
          <h4>WIDE COVERAGE</h4>
          <p>Whether it's airport transfers, city rides, or outstation trips — Prince Cabs covers all major destinations with reliable service.</p>
        </div>
      </div>
    </div>

    <div className="col-lg-4">
      <div className="about-service">
        <div className="about-service-icon">
          <img src="/images/icon17.png" alt="Personal service" />
        </div>
        <div className="about-service-content">
          <h4>PERSONALIZED SERVICE</h4>
          <p>Experience thoughtful service tailored to your travel needs. Our courteous drivers and customer-first approach set us apart.</p>
        </div>
      </div>
    </div>
  </div>
</div>


         
        </div>
      </div>

    

      {/* callback section */}
     <div
  className="fullwidth-callback"
  style={{ backgroundImage: "url(/images/img26.jpg)" }}
>
  <div className="container">
    <div className="section-heading section-heading-white text-center">
      <div className="row">
        <div className="col-lg-8 offset-lg-2">
          <h5 className="dash-style">CALLBACK FOR MORE</h5>
          <h2>RIDE WITH COMFORT. TRUST PRINCE CABS!</h2>
          <p>
            At Prince Cabs, we're not just a ride — we're your trusted partner in travel. Whether
            it's a quick city trip or a long-distance journey, we ensure every ride is safe,
            smooth, and memorable. Your comfort and satisfaction are always our top priority.
          </p>
        </div>
      </div>
    </div>

    <div className="callback-counter-wrap">
      {[
        { icon: "icon1.png", value: "100", suffix: "K+", text: "Happy Customers" },
        { icon: "icon2.png", value: "50", suffix: "+", text: "Cities Covered" },
        { icon: "icon3.png", value: "200", suffix: "+", text: "Professional Drivers" },
        { icon: "icon4.png", value: "24", suffix: "/7", text: "Service Availability" },
      ].map((it, i) => (
        <div className="counter-item" key={i}>
          <div className="counter-item-inner">
            <div className="counter-icon">
              <img src={`/images/${it.icon}`} alt={it.text} />
            </div>
            <div className="counter-content">
              <span className="counter-no">
                <span className="counter">{it.value}</span>
                {it.suffix}
              </span>
              <span className="counter-text">{it.text}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>

    </section>
<VisionMission/>
    <AboutTestimonialSection/>
</>
  );
}
